module.exports = __webpack_public_path__ + "img/img10.8b1a9f04.png";